import React from "react";
import { compose } from "redux";
import isNil from "lodash/isNil";
import { connect } from "react-redux";
import { Grid, withStyles } from "@material-ui/core";

import { HeaderBase, LogoAndAppTitle } from "altus-ui-components";

import { getWorkScheduleReportFromState } from "features/planner/report/report.selectors";
import WorkScheduleReportForm from "features/planner/report/workSchedule/components/WorkScheduleReportForm";

const WorkScheduleReportContainer = ({ report, classes }) => {
  const reportType = report.getIn(["parameters", "reportType"]);

  return (
    <HeaderBase
      classes={{
        root: classes.root,
      }}
    >
      <Grid item className={classes.logo}>
        <LogoAndAppTitle title="Report" to={null} />
      </Grid>
      <Grid xs item container spacing={2} alignItems="center">
        {!isNil(reportType) && (
          <WorkScheduleReportForm reportType={reportType} />
        )}
      </Grid>
    </HeaderBase>
  );
};

const styles = theme => ({
  root: {
    padding: `${theme.spacing(0.5)}px 0`,
    backgroundColor: theme.palette.grey[900],
  },
  logo: {
    paddingRight: theme.spacing(5),
  },
});

export default compose(
  connect(state => ({
    report: getWorkScheduleReportFromState(state),
  })),
  withStyles(styles),
)(WorkScheduleReportContainer);
